<div class="row" *ngIf="isBasica">
  <!-- <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{ step }}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Disco APOLLO</mat-label>
                <mat-select #txtHibrido formControlName="disco_apollo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterDiscoApollo($event.target.value)" />
                  <mat-option *ngFor="let item of listDiscoApollo" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.disco_apollo) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Anel APOLLO</mat-label>
                <mat-select #txtAnelApollo formControlName="anel_apollo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterAnelApollo($event.target.value)" />
                  <mat-option *ngFor="let item of listAnelApollo" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.anel_apollo) }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">% Falha APOLLO</mat-label>
                <input matInput id="txtPrcFalhaApollo" #txtPrcFalhaApollo maxlength="10"
                  formControlName="prc_falha_apollo" currencyMask (blur)="checkPrc($event.target, 'prc_falha_apollo')"
                  (blur)="makeCalculations()" [options]="{ thousands: '.', decimal: ',', precision: 1}">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">Somente Números de 0 a 30 são
                  aceitos
                </mat-hint>
                <mat-hint align="end">{{txtPrcFalhaApollo.value.length}} / 10</mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.prc_falha_apollo) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">% Dupla APOLLO</mat-label>
                <input matInput id="txtPrcDuplaApollo" #txtPrcDuplaApollo maxlength="10"
                  formControlName="prc_dupla_apollo" currencyMask (blur)="checkPrc($event.target, 'prc_dupla_apollo')"
                  (blur)="makeCalculations()" [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">Somente Números de 0 a 30 são
                  aceitos
                </mat-hint>
                <mat-hint align="end">{{txtPrcDuplaApollo.value.length}} / 10</mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.prc_dupla_apollo) }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">% Singulação APOLLO</mat-label>
                <input matInput id="txtPrcSingulacaoApollo" #txtPrcSingulacaoApollo maxlength="10"
                  formControlName="prc_singulacao_apollo" readonly class="InputBlockColor" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                </mat-hint>
                <mat-hint align="end">{{txtPrcSingulacaoApollo.value.length}} / 10</mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.prc_singulacao_apollo) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Motivo Reprovação Precision Planting</mat-label>
                <input matInput id="txtMotivoReprovacao" readonly class="InputBlockColor" #txtMotivoReprovacao
                  maxlength="100" formControlName="motivo_reprovacao_precision_planting">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{txtMotivoReprovacao.value.length}} / 100</mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.motivo_reprovacao_precision_planting) }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Resultado Precision Planting</mat-label>
                <input matInput id="txtResultadoPrecision" readonly class="InputBlockColor" #txtResultadoPrecision
                  maxlength="10" formControlName="resultado_precision_planting">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="end">{{txtResultadoPrecision.value.length}} / 10</mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.resultado_precision_planting) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Grafite</mat-label>
                <mat-select #txtGrafite formControlName="grafite" disableCenteringOption
                  [(ngModel)]="ngSelectedGrafite">
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterHibrido($event.target.value)" />
                  <mat-option *ngFor="let item of listGrafite" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.grafite) }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div> -->

  <div class="row" *ngIf="isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
      <mat-card class="mat-elevation-z8 w-100">
        <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
          <div class="row">
            <div class="col-lg col-md col-xs col-xl col-sm">
              <p class="tituloLeft">{{ step }}</p>
            </div>
            <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
              <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                *ngIf="!collapseCard"></i>
              <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                *ngIf="collapseCard"></i>
            </div>
          </div>
          <mat-card-content *ngIf="!collapseCard">


            <!-- 1. Disco Socidisco / 2. Anel Socidisco-->
            <div class="row pt-3">
              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                  floatLabel="{{ formFieldFloatLabel }}">
                  <mat-label class="InputLabelColor">Disco SOCIDISCO </mat-label>
                  <mat-select #txtDiscoSocidisco formControlName="disco_socidisco" disableCenteringOption>
                    <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                      (keyup)="createFilterDiscoSocidisco($event.target.value)" />
                    <mat-option *ngFor="let item of listDiscoSocidisco" [value]="item.name">
                      {{ item.name | uppercase }}
                    </mat-option>
                  </mat-select>
                  <i matSuffix class="{{ iconEnableField }}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.disco_socidisco) }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                  floatLabel="{{ formFieldFloatLabel }}">
                  <mat-label class="InputLabelColor">Anel SOCIDISCO</mat-label>
                  <mat-select #txtAnelSocidisco formControlName="anel_socidisco" disableCenteringOption>
                    <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                      (keyup)="createFilterAnelSocidisco($event.target.value)" />
                    <mat-option *ngFor="let item of listAnelSocidisco" [value]="item.name">
                      {{ item.name | uppercase }}
                    </mat-option>
                  </mat-select>
                  <i matSuffix class="{{ iconEnableField }}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.anel_socidisco) }}
                  </mat-error>
                </mat-form-field>
              </div>

            </div>
            <!-- Falha Socidisco / Dupla Socidisco -->
            <div class="row pt-3">
              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">% Falha SOCIDISCO</mat-label>
                  <input matInput id="txtPrcFalhaSocidisco" #txtPrcFalhaSocidisco maxlength="10"
                    formControlName="prc_falha_socidisco" currencyMask
                    (blur)="checkPrc($event.target, 'prc_falha_socidisco')" (blur)="makeCalculations()"
                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                  <i matSuffix class="{{iconEnableField}}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor">Somente Números de 0 a 30 são
                    aceitos
                  </mat-hint>
                  <mat-hint align="end">{{txtPrcFalhaSocidisco.value.length}} / 10</mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.prc_falha_socidisco) }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">% Dupla SOCIDISCO</mat-label>
                  <input matInput id="txtPrcDuplaSocidisco" #txtPrcDuplaSocidisco maxlength="10"
                    formControlName="prc_dupla_socidisco" currencyMask
                    (blur)="checkPrc($event.target, 'prc_dupla_socidisco')" (blur)="makeCalculations()"
                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                  <i matSuffix class="{{iconEnableField}}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor">Somente Números de 0 a 30 são
                    aceitos
                  </mat-hint>
                  <mat-hint align="end">{{txtPrcDuplaSocidisco.value.length}} / 10</mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.prc_dupla_socidisco) }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- Singulação Socidisco -->
            <div class="row pt-3">
              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">% Singulação SOCIDISCO </mat-label>
                  <input matInput id="txtPrcSingulcaoSocidisco" #txtPrcSingulcaoSocidisco maxlength="10"
                    formControlName="prc_singulacao_socidisco" currencyMask
                    [options]="{ thousands: '.', decimal: ',', precision: 0 }" readonly class="InputBlockColor">
                  <i matSuffix class="{{iconDisableField}}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor">
                  </mat-hint>
                  <mat-hint align="end">{{txtPrcSingulcaoSocidisco.value.length}} / 10</mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.prc_singulacao_socidisco) }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">% Singulação APOLLO</mat-label>
                  <input matInput id="txtPrcSingulacaoApollo" #txtPrcSingulacaoApollo maxlength="10"
                    formControlName="prc_singulacao_apollo" readonly class="InputBlockColor" currencyMask
                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                  <i matSuffix class="{{iconDisableField}}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor">
                  </mat-hint>
                  <mat-hint align="end">{{txtPrcSingulacaoApollo.value.length}} / 10</mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.prc_singulacao_apollo) }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                  floatLabel="{{ formFieldFloatLabel }}">
                  <mat-label class="InputLabelColor">Disco APOLLO</mat-label>
                  <mat-select #txtHibrido formControlName="disco_apollo" disableCenteringOption>
                    <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                      (keyup)="createFilterDiscoApollo($event.target.value)" />
                    <mat-option *ngFor="let item of listDiscoApollo" [value]="item.name">
                      {{ item.name | uppercase }}
                    </mat-option>
                  </mat-select>
                  <i matSuffix class="{{ iconEnableField }}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.disco_apollo) }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                  floatLabel="{{ formFieldFloatLabel }}">
                  <mat-label class="InputLabelColor">Anel APOLLO</mat-label>
                  <mat-select #txtAnelApollo formControlName="anel_apollo" disableCenteringOption>
                    <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                      (keyup)="createFilterAnelApollo($event.target.value)" />
                    <mat-option *ngFor="let item of listAnelApollo" [value]="item.name">
                      {{ item.name | uppercase }}
                    </mat-option>
                  </mat-select>
                  <i matSuffix class="{{ iconEnableField }}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.anel_apollo) }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">% Falha APOLLO</mat-label>
                  <input matInput id="txtPrcFalhaApollo" #txtPrcFalhaApollo maxlength="10"
                    formControlName="prc_falha_apollo" currencyMask (blur)="checkPrc($event.target, 'prc_falha_apollo')"
                    (blur)="makeCalculations()" [options]="{ thousands: '.', decimal: ',', precision: 1}">
                  <i matSuffix class="{{iconEnableField}}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor">Somente Números de 0 a 30 são
                    aceitos
                  </mat-hint>
                  <mat-hint align="end">{{txtPrcFalhaApollo.value.length}} / 10</mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.prc_falha_apollo) }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">% Dupla APOLLO</mat-label>
                  <input matInput id="txtPrcDuplaApollo" #txtPrcDuplaApollo maxlength="10"
                    formControlName="prc_dupla_apollo" currencyMask (blur)="checkPrc($event.target, 'prc_dupla_apollo')"
                    (blur)="makeCalculations()" [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                  <i matSuffix class="{{iconEnableField}}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor">Somente Números de 0 a 30 são
                    aceitos
                  </mat-hint>
                  <mat-hint align="end">{{txtPrcDuplaApollo.value.length}} / 10</mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.prc_dupla_apollo) }}
                  </mat-error>
                </mat-form-field>
              </div>

            </div>

            <div class="row pt-3">
              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">Resultado Precision Planting</mat-label>
                  <input matInput id="txtResultadoPrecision" readonly #txtResultadoPrecision maxlength="10"
                    formControlName="resultado_precision_planting"
                    [ngStyle]="{'background-color': formulario.controls.resultado_precision_planting.value ==='APROVADO' ? 'green' : 'red'  } ">
                  <i matSuffix class="{{iconDisableField}}"></i>

                  <mat-hint align="end">{{txtResultadoPrecision.value.length}} / 10</mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.resultado_precision_planting) }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">Grafite</mat-label>
                  <mat-select #txtGrafite formControlName="grafite" disableCenteringOption
                    [(ngModel)]="ngSelectedGrafite">
                    <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                      (keyup)="createFilterHibrido($event.target.value)" />
                    <mat-option *ngFor="let item of listGrafite" [value]="item.name">
                      {{ item.name | uppercase }}
                    </mat-option>
                  </mat-select>
                  <i matSuffix class="{{iconEnableField}}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.grafite) }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">Motivo Reprovação Precision Planting</mat-label>
                  <input matInput id="txtMotivoReprovacao" readonly class="InputBlockColor" #txtMotivoReprovacao
                    maxlength="100" formControlName="motivo_reprovacao_precision_planting">
                  <i matSuffix class="{{iconDisableField}}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                  <mat-hint align="end">{{txtMotivoReprovacao.value.length}} / 100</mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.motivo_reprovacao_precision_planting) }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                  floatLabel="{{ formFieldFloatLabel }}">
                  <mat-label class="InputLabelColor">Liberação Especial</mat-label>
                  <mat-select #txtLiberar formControlName="liberacao_especial" (selectionChange)="changeSelect($event)"
                    disableCenteringOption>
                    <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                      (keyup)="createFilterHibrido($event.target.value)" />
                    <mat-option *ngFor="let item of listLiberacaoEspecial" [value]="item.name">
                      {{ item.name | uppercase }}
                    </mat-option>
                  </mat-select>
                  <i matSuffix class="{{ iconEnableField }}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                  <mat-error>
                    {{ hasErrorFormControl(formulario.controls.liberacao_especial) }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                  floatLabel="{{ formFieldFloatLabel }}">
                  <mat-label class="InputLabelColor">Motivo Liberação Especial</mat-label>
                  <input matInput id="txtMotivoLiberacaoEspecial" #txtMotivoLiberacaoEspecial maxlength="20"
                    formControlName="motivo_liberacao_especial" />
                  <i matSuffix class="{{ iconEnableField }}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor">Ex.: Aprovação somente em disco Apollo;
                    Direcionamento especial (plantio à vácuo)</mat-hint>
                  <mat-hint align="end">{{ txtMotivoLiberacaoEspecial.value.length }} / 20</mat-hint>
                  <mat-error>{{
                  hasErrorFormControl(formulario.controls.motivo_liberacao_especial)
                }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">Criado por</mat-label>
                  <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="40" formControlName="criado_por" readonly
                    class="InputBlockColor">
                  <i matSuffix class="{{iconDisableField}}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                  <mat-hint align="end">{{txtCriadoPor.value.length}} / 40</mat-hint>
                  <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </form>
      </mat-card>
    </div>
  </div>